// extracted by mini-css-extract-plugin
export default {"success":"styles_success__jimv8","error":"styles_error__J4lRU","info":"styles_info__i0beY"};